module.exports = __webpack_public_path__ + "img/2-1.6d3dcfa0.jpg";